module.exports = __webpack_public_path__ + "media/images/japan/schedule_arrow_2-bed3ba04f71a4438702db1e4fd513c87.svg";